import Url from "app/shared/constants/Url";

export const SURVEY_API_ENDPOINT = {
  counts: `${Url.nodeClientURL}/survey/counts`,
  surveyStats: `${Url.nodeClientURL}/survey-stats`,
  categories: `${Url.nodeClientURL}/survey/categories`,

  // GET /api/v1/survey — list all clients (Client Master: fetchClients)
  listNode: `${Url.nodeClientURL}/survey`,
  create: `${Url.nodeClientURL}/client`,

  // DELETE /api/v1/survey/:id — soft delete a client (Client Master: deleteClient)
  delete: (id) => `${Url.nodeClientURL}/survey/${id}`,
  clientDelete: (id) => `${Url.nodeClientURL}/client/${id}`,

  // PUT /api/v1/survey/:id/retrieve — restore a soft-deleted client (Client Master: restoreClient)
  restore: (id) => `${Url.nodeClientURL}/survey/${id}/retrieve`,

  details: (id) => `${Url.nodeClientURL}/client/${id}`,
  getBySurveyId: (surveyId) => `${Url.nodeClientURL}/survey/${surveyId}`,
  getByClientId: (clientId) => `${Url.nodeClientURL}/client/${clientId}`,
  update: (id) => `${Url.nodeClientURL}/client/${id}`,
  export: (id) => `${Url.nodeClientURL}/client/${id}/export`,
  logoUpload: `${Url.nodeClientURL}/client/logo`,
  part: (id) => `${Url.nodeClientURL}/survey/part/${id}`,
  section: `${Url.nodeClientURL}/survey/section`,
  sectionDetail: (id) => `${Url.nodeClientURL}/survey/section/${id}`,
  sectionDuplicate: (id) => `${Url.nodeClientURL}/survey/section/${id}/duplicate`,
  attachment: `${Url.nodeClientURL}/survey/attachment/upload`,
  question: `${Url.nodeClientURL}/survey/question`,
  questionDetail: (id) => `${Url.nodeClientURL}/survey/question/${id}`,
  upload: (id) => `${Url.nodeClientURL}/survey/${id}/upload`,
  sampleDownload: `${Url.nodeClientURL}/survey/sample-download`,
  created: `${Url.nodeClientURL}/survey/created`,

  // GET /api/v1/survey/form-list — list surveys for the Survey Summary table
  formList: `${Url.nodeClientURL}/survey/form-list`,
  // POST /api/v1/survey/save-form — unified save endpoint for both
  // "Save as Draft" and "Publish". Body carries the full survey tree
  // (client_id, survey_name, parts[].sections[].questions[]) plus an
  // `action` field ("draft" | "publish") that tells the backend which
  // status to persist the survey with.
  saveForm: `${Url.nodeClientURL}/survey/save-form`,

  // Sharing & public endpoints
  shareDetails: (id) => `${Url.nodeClientURL}/survey/${id}/share`,
  multipleQr: (id) => `${Url.nodeClientURL}/survey/${id}/multiple-qr`,
  downloadAllQr: (id) => `${Url.nodeClientURL}/survey/${id}/download-all-qr`,
  publicSurveyQr: (id) => `${Url.nodeClientURL}/public/survey/${id}/qr`,
  publicQrCode: (id) => `${Url.nodeClientURL}/survey/${id}/qr`,
  publicForm: (id) => `${Url.nodeClientURL}/survey/${id}/form`,
  publicResponse: (id) => `${Url.nodeClientURL}/survey/${id}/response`,
  form: (id) => `${Url.nodeClientURL}/survey/${id}/form`,

  translateBatch: `${Url.nodeClientURL}/translate/batch`,
  translateLanguages: `${Url.nodeClientURL}/translate/languages`,

  // Scoring APIs
    scoringSampleDownload: `${Url.nodeClientURL}/scoring/sample-download`,
    scoringUpload: `${Url.nodeClientURL}/scoring/upload`,
    scoringCategory: (categoryId) =>
    `${Url.nodeClientURL}/scoring/category/${categoryId}`,

    scoringCategoryUpdate: (id) =>
  `${Url.nodeClientURL}/scoring/${id}`,

  scoringCategoryDelete: (id) =>
  `${Url.nodeClientURL}/scoring/${id}`,

  // GET / POST / PUT /survey/basic-details — fetch and save survey basic details
  basicDetailsBySurvey: (surveyId) => `${Url.nodeClientURL}/survey/basic-details/survey/${surveyId}`,
  basicDetails: (id) => (id ? `${Url.nodeClientURL}/survey/basic-details/${id}` : `${Url.nodeClientURL}/survey/basic-details`),
  basicDetailsAlt: (id) => (id ? `${Url.nodeClientURL}/survey-basic-details/${id}` : `${Url.nodeClientURL}/survey-basic-details`),

  // GET /api/v1/survey-stats/response-conversion/:id — Top management analysis response conversion statistics
  responseConversion: (id) => `${Url.nodeClientURL}/survey-stats/response-conversion/${id}`,

  // Survey Settings APIs
  loadFullPageSettingsClient: (clientId) => `${Url.nodeClientURL}/survey/settings/client/${clientId}`,
  loadFullPageSettingsPageClient: (clientId) => `${Url.nodeClientURL}/survey/settings/page/client/${clientId}`,
  loadFullPageSettingsSurvey: (surveyId) => `${Url.nodeClientURL}/survey/settings/survey/${surveyId}`,
  loadFullPageSettingsPageSurvey: (surveyId) => `${Url.nodeClientURL}/survey/settings/page/survey/${surveyId}`,
  loadFullPageSettingsPage: (surveyId) => `${Url.nodeClientURL}/survey/settings/page/${surveyId}`,
  loadFullPageSettings: (surveyId) => `${Url.nodeClientURL}/survey-settings/page/${surveyId}`,
  saveAllPageSettingsPage: `${Url.nodeClientURL}/survey/settings/page/save-all`,
  saveAllPageSettingsPageSurvey: (surveyId) => `${Url.nodeClientURL}/survey/settings/page/${surveyId}/save-all`,
  saveAllPageSettings: (surveyId) => `${Url.nodeClientURL}/survey/settings/${surveyId}/save-all`,
  saveAllPageSettingsAlt: (surveyId) => `${Url.nodeClientURL}/survey-settings/page/${surveyId}/save-all`,

  surveyPlant: `${Url.nodeClientURL}/survey-settings/plant`,
  surveyPlantDetail: (id) => `${Url.nodeClientURL}/survey-settings/plant/${id}`,

  surveyGender: `${Url.nodeClientURL}/survey-settings/gender`,

  surveyAgeScale: `${Url.nodeClientURL}/survey-settings/age-scale`,
  surveyAgeRangeDetail: (id) => `${Url.nodeClientURL}/survey-settings/age-range/${id}`,

  surveyDesignation: `${Url.nodeClientURL}/survey/settings/designation`,
  surveyDesignationDetail: (id) => `${Url.nodeClientURL}/survey/settings/designation/${id}`,
  designation: `${Url.nodeClientURL}/survey/settings/designation`,
  designationDetail: (id) => `${Url.nodeClientURL}/survey/settings/designation/${id}`,

  surveyDepartment: `${Url.nodeClientURL}/survey/settings/department`,
  surveyDepartmentDetail: (id) => `${Url.nodeClientURL}/survey/settings/department/${id}`,
  department: `${Url.nodeClientURL}/survey/settings/department`,
  departmentDetail: (id) => `${Url.nodeClientURL}/survey/settings/department/${id}`,

  surveyEducation: `${Url.nodeClientURL}/survey/settings/education`,
  surveyEducationDetail: (id) => `${Url.nodeClientURL}/survey/settings/education/${id}`,
  education: `${Url.nodeClientURL}/survey/settings/education`,
  educationDetail: (id) => `${Url.nodeClientURL}/survey/settings/education/${id}`,

  // Management Structure APIs
  structureMode: (surveyId) => `${Url.nodeClientURL}/survey/settings/management/structure/${surveyId}`,
  saveStructureMode: `${Url.nodeClientURL}/survey/settings/management/structure`,
  saveStructureType: `${Url.nodeClientURL}/survey/settings/management/structure-type`,
  saveStructureConfig: `${Url.nodeClientURL}/survey/settings/management/config`,
  managementTreeAlt: (surveyId) => `${Url.nodeClientURL}/survey/settings/management/tree/${surveyId}`,
  managementStructureTree: (surveyId) => `${Url.nodeClientURL}/management-structure/tree/${surveyId}`,
  managementSubCategories: (parentId) => `${Url.nodeClientURL}/management-structure/categories/${parentId}/sub-categories`,
  categoriesSubCategories: (parentId) => `${Url.nodeClientURL}/categories/${parentId}/sub-categories`,
  managementCategories: `${Url.nodeClientURL}/management-structure/categories`,
  managementCategoryDetail: (id) => `${Url.nodeClientURL}/survey/settings/management/categories/${id}`,
  managementCategoryDetailAlt1: (id) => `${Url.nodeClientURL}/survey-settings/categories/${id}`,
  managementCategoryDetailAlt2: (id) => `${Url.nodeClientURL}/survey-settings/category/${id}`,
  managementSubCategoryDetailAlt1: (id) => `${Url.nodeClientURL}/survey-settings/sub-categories/${id}`,
  managementSubCategoryDetailAlt2: (id) => `${Url.nodeClientURL}/survey-settings/sub-category/${id}`,
  managementSubSubCategories: `${Url.nodeClientURL}/survey-settings/management/sub-sub-categories`,
  subCategoriesSubSubCategories: (parentId) => `${Url.nodeClientURL}/sub-categories/${parentId}/sub-sub-categories`,
  managementStructureType: (surveyId) => `${Url.nodeClientURL}/management-structure/structure-type/${surveyId}`,
  managementStructurePage: (surveyId) => `${Url.nodeClientURL}/survey-settings/management/structure-page/${surveyId}`,
  saveManagementStructureType: `${Url.nodeClientURL}/management-structure/structure-type`,

  // Scale Options APIs
  surveyQuestionScaleOptions: (scale) => `${Url.nodeClientURL}/survey/question/scale-options${scale ? `?scale=${scale}` : ""}`,
  saveSurveyQuestionScaleOptions: `${Url.nodeClientURL}/survey/question/scale-options`,
  // Form Hierarchy & Share APIs
  surveyDetailsById: (surveyId) => `${Url.nodeClientURL}/survey/${surveyId}`,
  surveyForm: (surveyId) => `${Url.nodeClientURL}/survey/${surveyId}/form`,
  surveyShare: (surveyId) => `${Url.nodeClientURL}/survey/${surveyId}/share`,
};

export const SURVEY_TABS = {
  DASHBOARD: "dashboard",
  ACTIVE: "active",
  COMPLETED: "completed",
  TEMPLATES: "templates",
};

export const SCALE_OPTIONS = ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"];